module.exports = __webpack_public_path__ + "img/fajowo.ae280104.png";